// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inactiveSlide--yVzo4:hover {\n    cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./src/apps/consumer/pages/Quotes/Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/InactiveUnsaved3dSlide/styles.css"],"names":[],"mappings":"AACI;IACI,eAAe;AACnB","sourcesContent":[".inactiveSlide {\n    &:hover {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inactiveSlide": "inactiveSlide--yVzo4"
};
export default ___CSS_LOADER_EXPORT___;
